module.exports = __webpack_public_path__ + "static/media/default_image.504974c4.svg";